var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "card text-white", class: _vm.backgroundColor },
    [
      _c("div", { staticClass: "card-header" }, [
        _vm._v("\n        " + _vm._s(_vm.title) + "\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c(
          "div",
          { staticClass: "accordion" },
          _vm._l(_vm.tasks, function (task) {
            return _c("timeline-task-item", {
              key: task.id,
              attrs: { name: _vm.name, task: task },
            })
          }),
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }